<template>
  <div>
    <el-card shadow="always">
      <el-page-header
        title
        @back="$router.push('/home').catch(() => {})"
        :content="$t('carga-objetos')"
      ></el-page-header>
    </el-card>
    <el-card>
      <el-form ref="ruleForm" label-position="top">
        <el-row type="flex" justify="end">
          <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
            <el-input
              :placeholder="$t('pesquisar')"
              prefix-icon="el-icon-search"
              v-model="filter"
            ></el-input>
          </el-col>
          <el-col :xs="12" :sm="6" :md="6" :lg="3" :xl="3">
            <el-button
              class="right"
              type="primary"
              icon="el-icon-plus"
              @click="add()"
              >{{ $t("nova-carga") }}</el-button
            >
          </el-col>
        </el-row>
      </el-form>
      <el-table
        :data="tableFiltered"
        stripe
        style="width: 100%"
        :default-sort="{ prop: 'name', order: 'ascending' }"
      >
        <el-table-column sortable prop="customer" :label="$t('cliente')" />
        <el-table-column sortable prop="service" :label="$t('servico')" />
        <el-table-column
          sortable
          width="90"
          align="center"
          prop="total"
          :label="$t('qtde')"
        ></el-table-column>
        <el-table-column
          sortable
          width="280"
          prop="tags"
          :label="$t('etiquetas')"
        ></el-table-column>
        <el-table-column
          sortable
          width="180"
          prop="status"
          :label="$t('status')"
        >
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 'Finalizado' ? 'success' : scope.row.status === 'Executando' ? 'info' : ''">{{ scope.row.status }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          sortable
          align="center"
          prop="progress"
          :label="$t('progresso-em-uso')"
        >
          <template slot-scope="scope">
            <el-progress v-if="scope.row.status !== 'Finalizado'" :text-inside="true" :stroke-width="26" :percentage="scope.row.progress"></el-progress>
            <span v-else>{{ scope.row.progress }}</span>
          </template>
        </el-table-column>
        <el-table-column sortable prop="createdAt" :label="$t('data')">
        </el-table-column>
        <el-table-column label="#" width="160">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.status === 'Finalizado'"
              type="success"
              icon="el-icon-download"
              @click="download(scope.row.id)"
              circle
            ></el-button>
            <el-button
              v-if="scope.row.status === 'Finalizado'"
              type="danger"
              icon="el-icon-delete"
              @click="remove(scope.row.id)"
              circle
            ></el-button>
            <el-button
              v-if="scope.row.status === 'Finalizado'"
              type="warning"
              icon="el-icon-edit"
              @click="edit(scope.row.id)"
              circle
            ></el-button>
            <el-button
              type="info"
              v-if="scope.row.status !== 'Finalizado'"
              icon="el-icon-refresh"
              @click="refresh(scope.row.id)"
              circle
            ></el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>
<script>
//import { UserService } from "@/services/users/user.services";
import { i18n } from "@/plugin/i18n";
import { LoadObjectService } from "@/services/load.object/loadobject.services";
import CustomerList from "@/xpost/views/register/customer/CustomerList";
import ZipMixins from "../../../mixins/zipcode";

export default {
  name: "LoadObjects",
  mixins: [ZipMixins],
  components: {
    CustomerList,
  },
  methods: {
    add() {
      var vm = this;
      vm.$router.replace({ name: "load.objects.add" });
    },
    edit(id) {
      var vm = this;
      vm.$router.replace({ name: "load.objects.edit", params: { id: id } });
    },
    fetchRecords() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      LoadObjectService.list()
        .then((response) => {
          vm.tableData = response.records;
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    refresh(id) {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      LoadObjectService.refresh(id)
        .then((response) => {
          const record = vm.tableData.find(x => x.id === id);
          if (response >= 100) {
            record.progress = 0;
            record.status = 'Finalizado';
          } else {
            record.progress = response;
          }
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    download(id) {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      LoadObjectService.download(id)
        .then((response) => {
          var downloadLink = document.createElement("a");
          downloadLink.href = response;
          downloadLink.download = `etiquetas.csv`;
          document.body.appendChild(downloadLink);
          downloadLink.click();
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());

    },
    remove(id) {
      const vm = this;
      this.$confirm(
        i18n.t("confirmar-eliminacao-carga-objeto"),
        i18n.tc("aviso"),
        {
          confirmButtonText: "OK",
          cancelButtonText: i18n.tc("cancelar"),
          type: i18n.tc("aviso"),
          center: true,
        }
      ).then(() => {
        const loading = vm.$loading(vm.$options.loading);
        LoadObjectService.delete(id)
          .then((response) => {
            vm.tableData.splice(
              vm.tableData.findIndex((x) => x.id === id),
              1
            );
            this.$message({
              type: "success",
              message: "Carga removida com sucesso!",
            });
          })
          .catch((error) => {
            this.$message({
              type: "error",
              message: error,
            });
          })
          .finally(() => loading.close());
      });
    },
  },
  computed: {
    tableFiltered() {
      return this.tableData.filter(
        (data) =>
          !this.filter ||
          data.service.toLowerCase().includes(this.filter.toLowerCase()) ||
          data.contract.toLowerCase().includes(this.filter.toLowerCase()) ||
          data.client.toLowerCase().includes(this.filter.toLowerCase())
      );
    },
  },
  mounted() {
    const vm = this;
    vm.fetchRecords();
  },
  data() {
    return {
      filter: "",
      tableData: [],
      customer: "",
    };
  },
};
</script>
<style>
.right {
  float: right;
}
.label {
  font-weight: bold;
}
</style>